import { useCepWorkspaceConfig } from "src/cep/use-cep-workspace-config";
import { useUser } from "src/contexts/user-context";
import { useShouldSuppressFeatureAnnouncements } from "src/hooks/use-should-suppress-feature-announcements";
import { isHightouchStaffUser } from "src/utils/user";

export const useShouldShowCepTos = () => {
  const { user } = useUser();
  const { config, isLoading } = useCepWorkspaceConfig();
  const shouldSuppressAnnouncements = useShouldSuppressFeatureAnnouncements();

  const isHightouchAdmin = isHightouchStaffUser(user?.admin_type);

  const shouldShowCepTos =
    // Wait for the config to load so the modal doesn't flash before we know
    // whether the workspace has already accepted.
    !isLoading &&
    config?.tos_accepted == null &&
    // Don't show the modal to HT admins, this makes it hard to demo or investigate workspaces
    !isHightouchAdmin &&
    !shouldSuppressAnnouncements;

  return { shouldShowCepTos };
};
